module.exports = __webpack_public_path__ + "static/media/BW201910_01.537ad602.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BW201910_01.jpg
// module id = 368
// module chunks = 0